var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"Select city"},on:{"change":function($event){return _vm.$emit('change', _vm.selectedCity)}},model:{value:(_vm.selectedCity),callback:function ($$v) {_vm.selectedCity=$$v},expression:"selectedCity"}},_vm._l((_vm.cities),function(city){return _c('el-option',{key:city,attrs:{"label":city,"value":city}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }